import React from 'react'
import { Badge, Icon, Tile, TileCaption } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { CourseMeta, OutcomeContent } from 'types/data'
import { useVideoContext, VideoContextProps } from '../VideoContext'

export const CourseContentTile = ({
  content,
  courseMeta,
  isPrioritized,
  onClick,
}: {
  content: OutcomeContent
  courseMeta: CourseMeta
  isPrioritized: boolean
  onClick: () => void
}) => {
  const { openVideo } = useVideoContext<VideoContextProps>()
  const { t } = useTranslation('@mc/next')

  return (
    <Tile
      onClick={() => {
        if (courseMeta.trailerId) {
          onClick()
          openVideo(courseMeta)
        }
      }}
    >
      <TileCaption position='right top' padding={2}>
        <Badge kind='dim'>
          <span className='mc-text--capitalize'>
            {t('outcomePage.tile.classInfoPill.type')}
            {content.numberOfLessons &&
              t('outcomePage.tile.classInfoPill.detail', {
                numberOfLessons: content.numberOfLessons,
              })}
          </span>
        </Badge>
      </TileCaption>
      {courseMeta.trailerId && (
        <TileCaption position='center center' padding={4}>
          <Icon kind='play-circle' className='mc-icon--6' />
        </TileCaption>
      )}
      <Image
        className='mc-corners--3'
        src={content.tileImgSrc}
        alt=''
        priority={isPrioritized}
        width={588}
        height={333}
        objectFit='cover'
      />
    </Tile>
  )
}
